import { CHANNEL_TYPE } from '@/utils/constants'

export const getTrendsSuggestions = () => {
  return [
    { text: 'Why were these calls grouped together?' },
    { text: 'What patterns do agents follow here?' },
    { text: 'Any notable outliers?' },
    { text: 'Summarize key themes' },
  ]
}

export const BALTO_GPT_SUGGESTIONS = [
  { text: 'What are the top {channel} reasons?', summarySection: 'reason' },
  { text: 'What are the top {channel} objections or topics?', summarySection: 'objections' },
  { text: 'Show me examples of successful {channel} interactions.', summarySection: 'next_steps' },
  { text: 'Summarize key themes from recent {channel}s.', summarySection: 'outcome' },
]

export const getBaltoGPTSuggestionsForChannel = (channel = CHANNEL_TYPE.CALL) => {
  return BALTO_GPT_SUGGESTIONS.map((suggestion) => ({
    ...suggestion,
    text: suggestion.text.replaceAll('{channel}', channel),
  }))
}

export const linkifyCallIds = (text) => {
  if (!text) {
    return ''
  }

  return text.replace(/\b(\d{9,})\b/g, '[$1](/calls/$1)')
}
